import { c as _c } from "react/compiler-runtime";
import { CAMPAIGNS_API } from 'modules/campaigns/api/constants';
import { CampaignId } from 'modules/campaigns/types/campaign-interface';
import { ContactCampaignStepInterface } from 'modules/contacts/types/contact-menu-interface';
import { RequestMethodsEnum } from 'shared/hooks/use-fetch/types';
import useUser from 'shared/hooks/use-user';
import { DataWithPaginationInterface } from 'shared/types/pagination-interface';
import { useControlledSwr } from 'shared/hooks/use-controlled-swr';
import { RequestModuleEnum } from 'shared/enums/request-module-enum';
import { useFetch } from 'shared/hooks/use-fetch';
interface UseContactCampaignsProps {
  shouldFetch: boolean;
  id: CampaignId | undefined;
}
export function useContactCampaigns(t0) {
  const $ = _c(7);
  const {
    shouldFetch,
    id
  } = t0;
  const {
    user
  } = useUser();
  let t1;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t1 = {
      method: RequestMethodsEnum.get
    };
    $[0] = t1;
  } else {
    t1 = $[0];
  }
  const {
    fetcher
  } = useFetch(t1);
  let t2;
  if ($[1] !== id || $[2] !== shouldFetch) {
    t2 = () => shouldFetch && id !== undefined && [`${CAMPAIGNS_API}/${id}/list-steps`, RequestModuleEnum.CampaignStep];
    $[1] = id;
    $[2] = shouldFetch;
    $[3] = t2;
  } else {
    t2 = $[3];
  }
  const {
    data: campaignSteps,
    isValidating: isStepsValidating
  } = useControlledSwr(t2, fetcher, undefined, !!user);
  let t3;
  if ($[4] !== campaignSteps || $[5] !== isStepsValidating) {
    t3 = {
      campaignSteps,
      isStepsValidating
    };
    $[4] = campaignSteps;
    $[5] = isStepsValidating;
    $[6] = t3;
  } else {
    t3 = $[6];
  }
  return t3;
}